import { AppState } from '../root.reducer';
import { CardCheckErrorData } from './card-check.types';

export const getIsCardCheckErrorModalOpen = (state: AppState): boolean => state.cardCheck.isCardCheckErrorModalOpen;
export const getCardCheckErrorData = (state: AppState): CardCheckErrorData | null => state.cardCheck.cardCheckErrorData;
